// Core
import React, { useState } from 'react';
import Slider from 'react-slick';
import { Box, Text, Button, Image, useBreakpointValue } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Components
import Card from 'components/Card/Card';
import { ReviewsIcon, LeftIcon, RightIcon } from 'components/Icons/Icons';
import { galleryList } from './DataList';

const WinnersSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const settings = {
        dots: true, 
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0%',
        autoplay: true,
        autoplaySpeed: 2000, 
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        nextArrow: <></>,
        prevArrow: <></>,
    };

    const responsiveSettings = useBreakpointValue({
        base: {...settings, slidesToShow: 1}, 
        md: settings 
    });

    return (
        <Box 
          position="relative"
          left="50%"
          transform="translateX(-50%)"
          width={{base: '100%', sm: '90vw', md: '120vw'}}
          zIndex="1"
          overflow="visible"
          mt="36px"
          py="36px"
          whiteSpace="nowrap">
            <Slider {...responsiveSettings}>
                {galleryList.map((image, index) => (
                    <Box
                        key={index}
                        borderRadius="16px"
                        transform={index === currentSlide ? 'scale(1.2)' : 'scale(1)'}
                        transition="transform 0.3s ease"
                        px="34px"
                    >
                        <>  
                            <Box position="relative" zIndex="1" mb="-1px" borderRadius="16px" 
                                bg={index === currentSlide ? '#20B3FD' : 'black'}
                                p={index === currentSlide ? '7px' : '0'}
                                border={index === currentSlide ? 'unset' : '1px solid #262D47'}>
                                <Image 
                                    src={image} 
                                    opacity={index === currentSlide ? '1' : '0.64'}
                                    alt="Gallery" 
                                    w="100%" 
                                    h="325px" 
                                    borderRadius="11px" 
                                    objectFit="cover" />
                            </Box>
                        </>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};

export default WinnersSlider;
